import { useMemo } from 'react';
import { orderBy } from 'lodash';

import { ISelectModel, ISelectModelCode } from 'common/models';

const valuesOrderedByAsc = <T extends ISelectModel<string | number>>(data: T[]) => {
  return orderBy(data, ['label'], ['asc']);
};

export const transformCommonDropdownValues = () => {
  const transformPartnersSuppliers = (partnersSuppliers: ISelectModel<string | number>[]) => {
    const transformedPartnersSuppliers = partnersSuppliers?.map((item: any) => {
      const { firstName, partnerId } = item;

      return { label: firstName, value: partnerId };
    });

    return valuesOrderedByAsc(transformedPartnersSuppliers);
  };

  const transformTypeOfServiceData = (typeOfServiceData: ISelectModel<string | number>[]) => {
    const transformedTypeOfServiceData = typeOfServiceData?.map(
      (item: ISelectModel<string | number>) => {
        const { value, label } = item;

        return {
          value: +value,
          label: label,
        };
      },
    );

    return valuesOrderedByAsc(transformedTypeOfServiceData);
  };

  const transformReservationLanguages = (reservationLanguages: ISelectModel<string | number>[]) => {
    const transformedReservationLanguages = reservationLanguages?.map((item: any) => {
      const { naziv, id } = item;

      return { label: naziv, value: id };
    });

    return valuesOrderedByAsc(transformedReservationLanguages);
  };

  const transformReservationStatuses = (
    reservationStatuses: ISelectModelCode<string | number>[],
  ) => {
    const transformedStatuses = reservationStatuses?.map((item: any) => {
      const { value, label, code } = item;

      return { label: `${code} - ${label}`, value };
    });

    return valuesOrderedByAsc(transformedStatuses);
  };

  const transformRenters = (renters: any) => {
    const transformedRenters = renters?.map((item: any) => {
      const { firstName, lastName, partnerId } = item;

      return { label: `${firstName} ${lastName}`, value: partnerId };
    });

    return valuesOrderedByAsc(transformedRenters);
  };

  const transformCounties = (counties: any) => {
    const transformedCounties = counties?.map((item: any) => {
      const { naziv, sifra } = item;

      return { label: naziv, value: sifra };
    });

    return valuesOrderedByAsc(transformedCounties);
  };

  return {
    transformPartnersSuppliers,
    transformTypeOfServiceData,
    transformReservationLanguages,
    transformReservationStatuses,
    transformRenters,
    transformCounties,
  };
};
